const variants = {
  thead: {
    withoutBorderBottom: 'table-head-without-border-bottom',
    withBorderBottom: 'table-head-with-border-bottom',
    highlight: 'table-head-highlight',
  },
  tbody: {
    highlight: 'table-body-highlight',
    withBackground: 'table-body-with-background',
    'paddingBottom-10': 'table-body-padding-bottom-10',
  },
};

export default variants;
